export const CONFIGURATION_ERROR = "sso-configuration-error";

export const CONSENT_ERROR = "sso-consent-denied";

export const EMAIL_UNAVAILABLE = "sso-email-in-use";

export const EMAIL_NOT_SHARED = "sso-data-denied";

export const GENERIC_ERROR = "sso-generic";
